import React from 'react';
import { useSelector, shallowEqual } from 'react-redux';

import SeeAllTile from 'src/components/SeeAllTile';
import Tile from 'src/components/Tile/Tile';
import NoApplied from 'src/components/EmptyListing/NoApplied';

import 'src/containers/AppliedOffersContainer.scss';


const color = {
  blue: '#40B4E5',
  green: '#0FB484',
  red: '#D31F62',
  black: '#262626'
};

const applicationStatusColor = {
  fallback: color.blue,
  Delivered: color.blue,
  Opened: color.green,
  Rejected: color.red,
  Processing: color.green,
  Completed: color.black,
  Employed: color.green,
  ExternalAtsDelivered: color.blue
};

// eslint-disable-next-line max-lines-per-function
const AppliedOffersContainer = function () {
  const { jobOffersURL, myApplicationsURL } = useSelector(
    ({ configReducer }) => ({
      jobOffersURL: configReducer.jobOffersURL,
      myApplicationsURL: configReducer.myApplicationsURL
    }),
    shallowEqual
  );
  const offers = useSelector(
    ({ offersReducer }) => offersReducer.appliedOffers
  );
  const isLoggedIn = useSelector(({ credentialsReducer }) => Boolean(credentialsReducer.mpUserId));

  const statusText = 'Status:';

  const renderSeeAllTile = () => {
    const seeAllTitleText = 'Zobacz wszystkie wysłane aplikacje';
    const seeAllTitleContentUpperText = 'Zobacz wszystkie';
    const seeAllTitleContentLowerText = 'wysłane aplikacje';

    return (
      <SeeAllTile link={ myApplicationsURL } title={ seeAllTitleText }>
        <>
          {seeAllTitleContentUpperText}
          <br />
          {seeAllTitleContentLowerText}
        </>
      </SeeAllTile>
    );
  };

  if (offers.length === 0) {
    return <NoApplied isLoggedIn={ isLoggedIn } />;
  }

  return (
    <>
      {offers.map(
        ({
           applicationId,
           jobTitle,
           regionName,
           countryName,
           workplace,
           statusTranslation,
           actualStatus,
           logoFileUrl,
           offerURLName,
           companyName,
           isSuperOffer,
           isOneClickApply
         }) => {
          const jobLink = `${[jobOffersURL, offerURLName].join('/')}`;
          // eslint-disable-next-line security/detect-object-injection
          const pickedColor = applicationStatusColor[actualStatus]
            || applicationStatusColor.fallback;
          return (
            <Tile
              key={ applicationId }
              company={ companyName }
              id={ applicationId }
              isOneClickApply={ isOneClickApply }
              isSuperOffer={ isSuperOffer }
              job={ jobTitle }
              jobLink={ jobLink }
              location={ workplace || regionName || countryName }
              logo={ logoFileUrl }
            >
              <div styleName="status-placeholder">{statusText}</div>
              <div styleName="status" title={ statusTranslation }>
                <span
                  style={ { backgroundColor: pickedColor } }
                  styleName="status__circle"
                />
                <span
                  style={ { color: pickedColor } }
                  styleName="status__translation"
                >
                  {statusTranslation}
                </span>
              </div>
            </Tile>
          );
        }
      )}
      {renderSeeAllTile()}
    </>
  );
};

export default AppliedOffersContainer;
